import TableRow from '@mui/material/TableRow';
import Status from '../../../../shared/components/Status';
import { MaterialRequest } from '../../../../data/entities';
import { MATERIAL_REQUEST_STATUS } from "../../../../data/enums";
import { MaterialRequestFilterType, valueToText } from '../../../../configs/filterTypes';
import { StyledTableCell } from '../../../../shared/components/CustomTable/Styled';
import { StyledNavLink } from '../../../../shared/styled/TableStyles';
import { formatDateVi } from '../../../../utils/dateUtils';


export const getStatusColorTheme = (status: string) => {
    switch (status) {
        case MATERIAL_REQUEST_STATUS.OPEN:
            return 'INFO';
        case MATERIAL_REQUEST_STATUS.EXPORTING:
            return 'PENDING';
        case MATERIAL_REQUEST_STATUS.COMPLETED:
            return 'SUCCESS';
        case MATERIAL_REQUEST_STATUS.CANCELLED:
            return 'FAIL';
        default:
            return 'INFO';
    }
};

export const MaterialRequestRow = ({ item }: { item: MaterialRequest }) => {
    // const { user: {role} } = useContext(AuthenticationContext);

    return (
        <TableRow>
            <StyledTableCell align="left">
                <StyledNavLink to={`/material-requests/${item.id}`}>{item.request_name ? item.request_name : item.id}</StyledNavLink>
            </StyledTableCell>
            <StyledTableCell align="left">
                {item.sale_orders && item.sale_orders.length > 0 ? (
                    <>
                        {item.sale_orders.map((order, idx) => (
                            <span key={order.id}>
                                <StyledNavLink to={`/product-orders/${order.id}`}>
                                    {order.name}
                                </StyledNavLink>
                                {idx < item.sale_orders.length - 1 ? <span>, </span> : null}
                            </span>
                        ))}
                    </>
                ) : (
                    <span>-</span>
                )}
            </StyledTableCell>
            <StyledTableCell align="left">{formatDateVi(new Date(item.created_at))}</StyledTableCell>
            <StyledTableCell align="left">{formatDateVi(new Date(item.due_date))}</StyledTableCell>
            <StyledTableCell align="left">
                <Status
                    colorTheme={getStatusColorTheme(item.status)}
                    text={valueToText(MaterialRequestFilterType, 'status', item.status)}
                    width="124px"
                />
            </StyledTableCell>
            {/*<StyledTableCell align="left">*/}
            {/*    <Avatar sx={{ width: "24px", height: "24px" }} />*/}
            {/*</StyledTableCell>*/}
        </TableRow>
    );
};
